var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 19 20",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M16.5 2H12.32C11.9 0.84 10.8 0 9.5 0C8.2 0 7.1 0.84 6.68 2H2.5C1.4 2 0.5 2.9 0.5 4V18C0.5 19.1 1.4 20 2.5 20H16.5C17.6 20 18.5 19.1 18.5 18V4C18.5 2.9 17.6 2 16.5 2ZM9.5 2C10.05 2 10.5 2.45 10.5 3C10.5 3.55 10.05 4 9.5 4C8.95 4 8.5 3.55 8.5 3C8.5 2.45 8.95 2 9.5 2ZM11.5 16H4.5V14H11.5V16ZM14.5 12H4.5V10H14.5V12ZM14.5 8H4.5V6H14.5V8Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }